import React, { useState, useRef, useContext, useEffect } from "react";
import Select from "react-select";
import uuid from "react-uuid";
import { AiOutlinePlusCircle } from "react-icons/ai";

import { questionTypes } from "../constants/QuestionType";

import { useDispatch, useSelector } from "react-redux";
import {
  addQuestion,
  removeQuestion,
  reorderQuestion,
  updateForm,
  updateQuestions,
} from "../redux/actions/forms";
import { FaTrash } from "react-icons/fa";
import { TbDotsVertical } from "react-icons/tb";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { MdLinearScale, MdDragIndicator } from "react-icons/md";
import { RxSlider } from "react-icons/rx";
import { IoMdCheckbox, IoMdAttach } from "react-icons/io";
import { BiRadioCircleMarked } from "react-icons/bi";
import { add, remove } from "lodash";

const Paragraph = (props) => {
  return <div className='textInput formInputWrapper'>Short Answer Text</div>;
};

const Linear_Scale = (props) => {
  return (
    <div className='linearScaleInputWrapper formInputWrapper'>
      {Array(5)
        .fill(0)
        .map((input, idx) => (
          <>
            <div className='LinearScaleWrapper'>
              <input
                type='radio'
                name={props?.question?.questionTitle}
                id={props?.question?.questionTitle + (idx + 1)}
                className='linearScaleInput'
                disabled
              />
              <label
                htmlFor={props?.question?.questionTitle + (idx + 1)}
                className='linearScaleLabel'
              >
                {idx + 1}
              </label>
            </div>
          </>
        ))}
    </div>
  );
};
const CheckBox = (props) => {
  const [options, setOptions] = useState(
    props?.question?.questionMetadata?.choices || []
  );

  useEffect(() => {
    props?.updateChoices(options);
  }, [options]);
  const addOption = () => {
    let updatedOptions = structuredClone(options);
    updatedOptions = [...updatedOptions, "Add Option"];
    sendUpdatedOptions(updatedOptions);
  };
  const updateOption = (idx, value) => {
    let updatedOptions = structuredClone(options);
    updatedOptions[idx] = value;
    sendUpdatedOptions(updatedOptions);
  };

  const removeOption = (value) => {
    let updatedOptions = options?.filter((option) => option !== value);
    sendUpdatedOptions(updatedOptions);
  };

  const sendUpdatedOptions = (updatedOptions) => {
    setOptions(updatedOptions);
    props?.updateChoices(options);
  };

  return (
    <div className='choiceInput formInputWrapper'>
      {options?.map((option, idx) => (
        <div className='choiceInputWrapper'>
          <input
            type='checkbox'
            className='ui-checkbox'
            name={props?.question?.questionTitle}
            value={option}
            id={option}
            disabled
          />{" "}
          <input
            value={option}
            className='optionsInput'
            onChange={(e) => updateOption(idx, e.target.value)}
          />
          <div className='removeBtn' onClick={() => removeOption(option)}>
            <FaTrash />
          </div>
        </div>
      ))}
      <button
        className='btn btn-primary rounded-circle p-1 px-2 '
        onClick={addOption}
      >
        <AiOutlinePlusCircle />
        {/* Add Option */}
      </button>
    </div>
  );
};
const Radio = (props) => {
  const [options, setOptions] = useState(
    props?.question?.questionMetadata?.choices || []
  );

  useEffect(() => {
    props?.updateChoices(options);
  }, [options]);
  const addOption = () => {
    let updatedOptions = structuredClone(options);
    updatedOptions = [...updatedOptions, "Add Option"];
    sendUpdatedOptions(updatedOptions);
  };
  const updateOption = (idx, value) => {
    let updatedOptions = structuredClone(options);
    updatedOptions[idx] = value;
    sendUpdatedOptions(updatedOptions);
  };

  const removeOption = (value) => {
    let updatedOptions = options?.filter((option) => option !== value);
    sendUpdatedOptions(updatedOptions);
  };

  const sendUpdatedOptions = (updatedOptions) => {
    setOptions(updatedOptions);
    props?.updateChoices(options);
  };

  return (
    <div className='choiceInput formInputWrapper'>
      {options?.map((option, idx) => (
        <div className='choiceInputWrapper'>
          <input
            type='radio'
            className='ui-checkbox ui-radio'
            name={props?.question?.questionTitle}
            value={option}
            id={option}
            disabled
          />{" "}
          <input
            value={option}
            className='optionsInput'
            onChange={(e) => updateOption(idx, e.target.value)}
          />
          <div className='removeBtn' onClick={() => removeOption(option)}>
            <FaTrash />
          </div>
        </div>
      ))}
      <button
        className='btn btn-primary rounded-circle p-1 px-2 '
        onClick={addOption}
      >
        <AiOutlinePlusCircle />
        {/* Add Option */}
      </button>
    </div>
  );
};
const Range = (props) => {
  const [range, setRange] = useState({
    min: props?.question?.questionMetadata?.min || 1,
    max: props?.question?.questionMetadata?.max || 100,
  });
  useEffect(() => {
    props?.updateChoices(range);
  }, [range]);
  return (
    <div className='rangeInput formInputWrapper'>
      {/* <label for={props?.questionTitle}>{props?.labelStart}</label> */}
      <div className='minMaxLabelWrapper flex'>
        <div className='minMaxLabel'>
          <span>Min</span>
          <input
            type='number'
            defaultValue={1}
            onChange={(e) =>
              setRange({ ...range, min: parseInt(e.target.value) })
            }
            className='rangeMeterInput'
          />
        </div>
        <div className='minMaxLabel'>
          <span>Max</span>
          <input
            type='number'
            defaultValue={100}
            onChange={(e) =>
              setRange({ ...range, max: parseInt(e.target.value) })
            }
            className='rangeMeterInput'
          />
        </div>
      </div>
      <div className='range-input'>
        <input
          type='range'
          name={props?.question?.questionTitle}
          id={props?.question?.questionTitle}
          min={range?.min}
          max={range?.max}
          disabled
        />
      </div>
    </div>
  );
};

const FileUpload = (props) => {
  return (
    <div className='fileInput formInputWrapper'>
      <input
        type='file'
        name={props?.question?.questionTitle}
        id={props?.question?.questionTitle}
        disabled
      />
    </div>
  );
};

const Draggable = (props) => {
  const currentForm = useSelector((state) => state.allForms.currentForm);
  const dragItem = useRef();
  const dragOverItem = useRef();

  const dispatch = useDispatch();
  const [list, setList] = useState(() => {
    if (currentForm) return currentForm.questions;
    else
      return [
        {
          id: uuid(),
          questionTitle: "Sample Question",
          questionType: questionTypes.PARAGRAPH,
        },
      ];
  });
  const [count, setCount] = useState(1);
  const [file, setFile] = useState(null);

  const dragStart = (e, position) => {
    dragItem.current = position;
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e) => {
    const copyListItems = [...list];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setList(copyListItems);
    dispatch(reorderQuestion(copyListItems));
    // updateCurrentFormQuestion(copyListItems);
  };

  useEffect(() => {
    setFile(currentForm?.formTheme?.image);
  }, []);
  useEffect(() => {
    setList(currentForm?.questions);
    setFile(currentForm?.formTheme?.image);
    dispatch(updateForm());
  }, [currentForm]);

  useEffect(() => {
    dispatch(updateQuestions(list));
  }, [list]);

  const addNewQuestion = () => {
    let newQuestion = {
      id: uuid(),
      questionTitle: `Text Question ${count}`,
      questionType: questionTypes.PARAGRAPH,
      required: true,
    };

    dispatch(addQuestion(newQuestion));
    setCount(count + 1);
  };
  const options = [
    {
      value: "PARAGRAPH",
      label: (
        <>
          <HiOutlineMenuAlt4 /> <span className='select-label'>Text</span>
        </>
      ),
    },
    {
      value: "LINEAR_SCALE",
      label: (
        <>
          <MdLinearScale /> <span className='select-label'>Linear Scale</span>
        </>
      ),
    },
    {
      value: "RANGE",
      label: (
        <>
          <RxSlider /> <span className='select-label'>Range</span>
        </>
      ),
    },
    {
      value: "CHECKBOX",
      label: (
        <>
          <IoMdCheckbox /> <span className='select-label'>CheckBox</span>
        </>
      ),
    },
    {
      value: "RADIO",
      label: (
        <>
          <BiRadioCircleMarked /> <span className='select-label'>Radio</span>
        </>
      ),
    },
    {
      value: "UPLOAD",
      label: (
        <>
          <IoMdAttach /> <span className='select-label'>AttachFile</span>
        </>
      ),
    },
  ];
  const styles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      minWidth: "150px",
    }),
  };
  const updateQuestionTitle = (title, index) => {
    let newList = [...list];
    newList[index].questionTitle = title;
    setList(newList);
  };

  const updateQuestionType = (type, index) => {
    // console.log(type);
    let newList = [...list];
    newList[index].questionType = type;
    setList(newList);
  };
  const updateQuestionChoices = (data, index) => {
    let newList = structuredClone(list);
    let choiceData = { choices: data };
    newList[index].questionMetadata = choiceData;
    newList.forEach((listTemp) => {
      delete listTemp.__typename;
    });

    setList(newList);
  };
  const updateQuestionRange = (data, index) => {
    let newList = structuredClone(list);
    newList[index].questionMetadata = data;
    newList.forEach((listTemp) => {
      delete listTemp.__typename;
    });

    setList(newList);
  };

  const updateQuestionRequired = (required, index) => {
    let newList = [...list];
    newList[index].required = required;
    setList(newList);
  };
  const deleteQuestion = (question) => {
    // let newList = list.filter((item) => item.id !== id);
    // setList(newList);
    dispatch(removeQuestion(question));
    // setList();
  };

  return (
    <section className='questionsWrapper flex-col items-center content-center'>
      {/* <>FormTitle:{JSON.stringify(currentForm?.formTitle)}</>
      <>Description: {JSON.stringify(currentForm?.description)}</>
      <>Questions: {JSON.stringify(currentForm?.questions)}</> */}
      {currentForm && currentForm?.formMetadata?.theme?.image && (
        <div
          className='questionWrapper rounded'
          style={{
            backgroundImage: `url('${currentForm?.formMetadata?.theme?.image}')`,
            backgroundSize: "cover",
            minHeight: "250px",
            overflow: "hidden",
            width: "90%",
          }}
        >
          {/* <img
            src={currentForm?.formMetadata?.theme?.formImage}
            alt=''
            style={{ width: "100%" }}
          /> */}
        </div>
      )}
      {list?.length == 0 && (
        <h4 style={{ margin: "15px 0" }}>No Questions yet</h4>
      )}

      {currentForm &&
        list?.map((item, index) => (
          <div
            onDragStart={(e) => dragStart(e, index)}
            onDragEnter={(e) => dragEnter(e, index)}
            onDragEnd={drop}
            key={index}
            draggable
            style={{ width: "90%" }}
          >
            <div
              className='d-flex items-center justify-between my-2 py-0 px-2 rounded border border-2 border-dark'
              style={{ background: "#fff", cursor: "grab", width: "100%" }}
            >
              <MdDragIndicator size={15} />
              <div
                className='questionWrapper flex-col items-start content-between 
                border-0 
                '
                id={item?.id}
                // style={{ width: "90%" }}
              >
                <div className='questionTop flex content-start  '>
                  <input
                    className='questionTitle'
                    value={item?.questionTitle}
                    onChange={(e) => updateQuestionTitle(e.target.value, index)}
                  />

                  <Select
                    options={options}
                    className='questionType'
                    styles={styles}
                    value={options.filter(
                      (x) => x.value === item?.questionType
                    )}
                    onChange={(e) => updateQuestionType(e.value, index)}
                  />
                </div>
                <div className='questionDetails'>
                  {item?.questionType === questionTypes.PARAGRAPH && (
                    <Paragraph />
                  )}
                  {item?.questionType === questionTypes.CHECKBOX && (
                    <CheckBox
                      question={item}
                      updateChoices={(e) => updateQuestionChoices(e, index)}
                    />
                  )}
                  {item?.questionType === questionTypes.LINEAR_SCALE && (
                    <Linear_Scale question={item} />
                  )}
                  {item?.questionType === questionTypes.RADIO && (
                    <>
                      <Radio
                        question={item}
                        updateChoices={(e) => updateQuestionChoices(e, index)}
                      />
                    </>
                  )}
                  {item?.questionType === questionTypes.RANGE && (
                    <Range
                      question={item}
                      updateChoices={(e) => updateQuestionRange(e, index)}
                    />
                  )}
                  {item?.questionType === questionTypes.UPLOAD && (
                    <FileUpload question={item} />
                  )}
                </div>
                <div className='questionFooter flex items-center content-end position-relative'>
                  <div className='questionFooterDiv flex items-center content-center'>
                    Required
                    <label className='switch'>
                      <input
                        type='checkbox'
                        checked={item?.required}
                        onChange={(e) =>
                          updateQuestionRequired(e.target.checked, index)
                        }
                      />
                      <span className='slider'></span>
                    </label>
                  </div>
                  <div
                    className='questionFooterDiv flex items-center content-center questionFooterIcon'
                    onClick={(e) => deleteQuestion(item)}
                  >
                    <FaTrash style={{ pointerEvents: "none" }} />
                  </div>
                  {/* <div className="questionFooterDiv flex items-center content-center questionFooterIcon">
                    <TbDotsVertical style={{ pointerEvents: "none" }} />
                  </div> */}
                </div>
              </div>
            </div>
            {/* <Questions question={item} /> */}
          </div>
        ))}
      {currentForm && (
        <button
          className='btn addQuestionBtn flex items-center content-center'
          onClick={() => addNewQuestion()}
        >
          <AiOutlinePlusCircle style={{ pointerEvents: "none" }} />
          Add New Question
        </button>
      )}
    </section>
  );
};
export default Draggable;
